var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRakuten = function SvgRakuten(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1508.5 1605.1",
    style: {
      enableBackground: "new 0 0 1508.5 1605.1"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.rakuten0{fill:#BF0000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rakuten0",
    d: "M215.2,1605.1L0,1424.6h1508.5L215.2,1605.1z M460.2,1289.2V888.9h173.2l300,400.2h307.2l-363-482.9 C1077.5,664,1124.2,386.6,982,186.7C898.7,69.7,764,0.1,620.4,0H215.2v1289.2H460.2z M460.2,244.8h160.2 c110.3-3.6,202.7,83,206.2,193.4s-83,202.7-193.4,206.2c-4.3,0.1-8.6,0.1-12.9,0H460.2V244.8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRakuten);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "rakuten.3ba266762681f2588f2d404e9a6bee36.svg";